import axios from "axios";
import React, { useState } from "react";
import Box from "@mui/material/Box";
import Rating from "@mui/material/Rating";
import Typography from "@mui/material/Typography";
import { baseURL, getComments } from "../redux/Action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddComment = ({ id, setComments }) => {
  const { user, isAuth, token } = useSelector((state) => state);
  const navigate = useNavigate();

  const [message, setMessage] = useState({
    message: "",
  });
  const [value, setValue] = React.useState(2);

  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMessage({
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isAuth) {
      return navigate("/login");
    }
    const payload = {
      user_id: user.user._id,
      blog_id: id,
      ...message,
      rating: value,
      parentId: id,
    };
    const toastId = toast.loading("Appending to record...", { theme: "dark" });
    axios
      .post(`${baseURL}/comments`, payload, {
        withCredentials: true,
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        toast.update(toastId, {
          render: "Appendice Saved",
          type: "success",
          isLoading: false,
          theme: "dark",
          autoClose: 2000,
          closeOnClick: true,
        });
        getComments(dispatch, id);
        setComments((prev) => [...prev, payload]);
        setMessage({ message: "" });
      })
      .catch((err) => {
        toast.update(toastId, {
          render: "System Error. Entry failed.",
          type: "error",
          isLoading: false,
          autoClose: 2000,
          closeOnClick: true,
        });
      });
  };

  return (
    <div className="relative">
      <div className="mb-4">
        <span className="bg-black dark:bg-white text-white dark:text-black px-2 py-1 text-[10px] font-mono tracking-widest font-bold uppercase shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,0.5)]">
          Appendice Module / Input
        </span>
      </div>

      <form
        onSubmit={handleSubmit}
        className="relative bg-white dark:bg-black border-2 border-black dark:border-white/30 focus-within:ring-0 focus-within:bg-gray-50 dark:focus-within:bg-[#0a0a0a] transition-all flex flex-col"
      >
        <textarea
          name="message"
          id="message"
          rows="4"
          placeholder="TYPE YOUR ADDITION HERE..."
          className="w-full resize-none outline-none bg-transparent text-black dark:text-white font-mono text-sm px-6 py-6 placeholder-gray-400 dark:placeholder-gray-600 uppercase font-bold"
          value={message.message}
          onChange={handleChange}
          required
        ></textarea>

        <div className="flex items-center justify-between px-6 py-4 border-t-2 border-black dark:border-white/30 bg-white dark:bg-black">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              color: "currentColor",
            }}
          >
            <Typography
              component="span"
              fontSize="10px"
              fontWeight="700"
              fontFamily="monospace"
              className="text-black dark:text-white uppercase tracking-widest"
            >
              ASSESSMENT
            </Typography>
            <Rating
              name="simple-controlled"
              value={value}
              onChange={(event, newValue) => {
                setValue(newValue);
              }}
              size="small"
              sx={{
                "& .MuiRating-iconEmpty": {
                  color: "gray",
                },
                "& .MuiRating-iconFilled": {
                  color: "currentColor",
                },
              }}
            />
          </Box>
          <button
            type="submit"
            disabled={!message.message.trim()}
            className="px-6 py-2 text-[10px] uppercase tracking-widest font-black font-mono text-white dark:text-black bg-black dark:bg-white hover:bg-red-600 dark:hover:bg-red-500 disabled:bg-gray-300 dark:disabled:bg-gray-800 disabled:text-gray-500 dark:disabled:text-gray-600 disabled:cursor-not-allowed transition-colors shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,0.5)] active:shadow-none dark:active:shadow-none active:translate-y-0.5 active:translate-x-0.5 disabled:shadow-none disabled:translate-0"
          >
            EXECUTE
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddComment;
